import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { autoCompleteClient } from 'clients/AutoCompleteClient/AutoCompleteClient';
import { useGetAllAtsConnectionsQuery } from 'shared/legacy/hooks/useGetAllAtsConnectionsQuery';
import { QueryKey } from 'types/query';

export const useAtsVacancyQuery = ({ search, enabled }: { search: string; enabled?: boolean }) => {
  return useQuery(
    [QueryKey.useAtsVacancyQuery, search],
    async () => {
      const { data } = await autoCompleteClient.atsVacancy(search);

      return data.result?.results || [];
    },
    {
      keepPreviousData: true,
      cacheTime: ms('5 min'),
      staleTime: ms('5 min'),
      initialData: [],
      initialDataUpdatedAt: 0,
      enabled,
    },
  );
};

export const useAtsVacancyFullQuery = ({ id, enabled }: { id: string | undefined; enabled?: boolean }) => {
  const {
    data: { activeATS },
  } = useGetAllAtsConnectionsQuery();

  return useQuery(
    [QueryKey.useAtsVacancyFullQuery, id],
    async () => {
      if (!id) {
        throw new Error('No ATS Vacancy id provided');
      }
      const { data } = await autoCompleteClient.fullAtsVacancy(id);
      return data;
    },
    {
      keepPreviousData: true,
      cacheTime: ms('5 min'),
      staleTime: ms('5 min'),
      initialDataUpdatedAt: 0,
      enabled: typeof enabled === 'boolean' ? enabled : !activeATS && !!id,
    },
  );
};
